import Wrapper from './Wrapper';
import Toggle from './Toggle';

const Map = props => (
    <div id="metar-taf-map">
        <Wrapper {...props} />
    </div>
);

export {Map, Toggle};

export default Map;
